import React from 'react';
import LineCardTile from './linecardtile';
import '../scss/linecard.scss';
import LineCards from './data/linecard.json';

function LineCard() {
  var Cards = [];

  LineCards.forEach( (card) => {
    Cards.push(<LineCardTile name={card.name} image={card.image} description={card.description} infoLink={card.infolink}/>)
  });

  return (
    <div class="linecard-container text-center justify-content-center">
      <h3 class="d-lg-none linecard-title bottom-border">Line Card</h3>
      <div class="row justify-content-center">
        {Cards}
      </div>
    </div>
  );
}

export default LineCard;
